module.exports = __webpack_public_path__ + "678143480e2b8a3e07806c20b2c88681.png";